import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAdding ? "New carrier" : "Edit carrier"))])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.gettingEntity.isPending ? _c("div", {
    staticClass: "text-smaller text-italice"
  }, [_vm._v("Loading data")]) : [_c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isValid", $$v);
      },
      expression: "form.isValid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Email",
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeEmail]
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_vm.isAdding ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.form.isValid,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveAddingEntity();
      }
    }
  }, [_vm._v(" Create ")]) : _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.form.isValid,
      loading: _vm.updatingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveUpdatingEntity();
      }
    }
  }, [_vm._v(" Save ")])], 1)]], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };